(() => {
  if (window.pidjayProductLoaded) return;
  window.pidjayProductLoaded = true;

  function initialize(root) {
    if (!root || root.dataset.enhanced === 'true') return;
    root.dataset.enhanced = 'true';
    const gallery = root.querySelector('[data-gallery]');
    const showMedia = id => {
      if (!gallery) return;
      const media = [...gallery.querySelectorAll('[data-media-id]')];
      const active = media.find(item => item.dataset.mediaId === id) || media[0];
      media.forEach(item => {
        item.hidden = item !== active;
        if (item.hidden) item.querySelectorAll('video').forEach(video => video.pause());
      });
      gallery.querySelectorAll('[data-media-target]').forEach(link => {
        const selected = link.dataset.mediaTarget === active?.dataset.mediaId;
        link.classList.toggle('active', selected);
        if (selected) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    };
    showMedia(gallery?.dataset.featuredMedia);
    gallery?.addEventListener('click', event => {
      const link = event.target.closest('[data-media-target]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      showMedia(link.dataset.mediaTarget);
    });

    let controller;
    async function select(url) {
      controller?.abort();
      controller = new AbortController();
      const signal = controller.signal;
      const endpoint = new URL(url, window.location.href);
      if (endpoint.origin !== window.location.origin || endpoint.pathname !== window.location.pathname) {
        window.location.assign(endpoint.href);
        return;
      }
      root.setAttribute('aria-busy', 'true');
      const purchaseForm = root.querySelector('.native-product-form');
      if (purchaseForm) purchaseForm.inert = true;
      root.querySelectorAll('[data-add-to-cart]').forEach(button => { button.disabled = true; });
      const status = root.querySelector('[data-selection-status]');
      if (status) status.textContent = 'Updating your selection…';
      const fetchUrl = new URL(endpoint);
      fetchUrl.searchParams.set('section_id', root.dataset.sectionId);
      try {
        const response = await fetch(fetchUrl, { signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Selection could not be loaded');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = document.querySelector('[data-product-section]');
        if (signal.aborted) return;
        if (!next) throw new Error('Selection could not be loaded');
        const oldQuantity = Number(root.querySelector('[name="quantity"]')?.value);
        const quantity = next.querySelector('[name="quantity"]');
        if (quantity && Number.isInteger(oldQuantity)) {
          const min = Number(quantity.min) || 1;
          const max = quantity.max ? Number(quantity.max) : Infinity;
          const step = Number(quantity.step) || 1;
          if (oldQuantity >= min && oldQuantity <= max && (oldQuantity - min) % step === 0) quantity.value = String(oldQuantity);
        }
        root.replaceWith(next);
        history.replaceState({}, '', endpoint);
        initialize(next);
        next.querySelector('[name="variant"], [aria-current="true"].native-option-link')?.focus({ preventScroll: true });
        if (window.Shopify?.PaymentButton) window.Shopify.PaymentButton.init();
      } catch (error) {
        if (!signal.aborted && error.name !== 'AbortError') window.location.assign(endpoint.href);
      }
    }
    const picker = root.querySelector('[data-variant-picker]');
    picker?.addEventListener('submit', event => {
      event.preventDefault();
      const url = new URL(picker.action);
      new FormData(picker).forEach((value, name) => url.searchParams.set(name, value));
      select(url);
    });
    picker?.querySelector('select')?.addEventListener('change', () => picker.requestSubmit());
    root.querySelectorAll('[data-option-link]').forEach(link => link.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      select(link.href);
    }));
  }
  const scan = () => document.querySelectorAll('[data-product-section]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
